import { render } from "./AssignmentsView.vue?vue&type=template&id=0f6c52ce&scoped=true"
import script from "./AssignmentsView.vue?vue&type=script&lang=js"
export * from "./AssignmentsView.vue?vue&type=script&lang=js"

import "./AssignmentsView.vue?vue&type=style&index=0&id=0f6c52ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6c52ce"]])

export default __exports__